export default __webpack_public_path__ + "static/hackathon-steps-bg-3d1e95c6cf3df5db097f3dbe0a0ab361.jpg";